import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { RouteHelperService } from 'src/app/shared/services/route-helper.service';

@Component({
  templateUrl: './blank.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BlankComponent implements OnInit {
  constructor(private readonly tokenStorage: TokenStorageService, private readonly routeHelper: RouteHelperService) {}

  public ngOnInit(): void {
    if (!this.tokenStorage.userInfo) {
      this.routeHelper.login();
    }
  }
}
